<!-- Input field con icono -->
<div class="custom-date-picker">
  <div class="date-input-wrapper" [class.disabled]="disabled">
    <input 
      type="text" 
      readonly
      autocomplete="off"
      inputmode="none"
      [value]="formatDateForDisplay()" 
      [placeholder]="placeholder"
      [disabled]="disabled"
      (click)="toggleCalendar()"
      class="date-input">
    <mat-icon class="calendar-icon" (click)="toggleCalendar()">calendar_today</mat-icon>
  </div>

  <!-- Overlay para cerrar el calendario -->
  <div *ngIf="showCalendar" class="calendar-overlay" (click)="closeCalendar()"></div>

  <!-- Dropdown del calendario -->
  <div *ngIf="showCalendar" class="calendar-modal" #calendarModal (click)="$event.stopPropagation()">
    <!-- Header del calendario -->
    <div class="calendar-header">
      <button type="button" class="nav-button" (click)="previousMonth()">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <span class="month-year">{{ getCurrentMonthYear() }}</span>
      <button type="button" class="nav-button" (click)="nextMonth()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>

    <!-- Días de la semana -->
    <div class="weekdays">
      <div *ngFor="let day of weekDays" class="weekday">{{ day }}</div>
    </div>

    <!-- Días del mes -->
    <div class="calendar-grid">
      <div 
        *ngFor="let day of getDaysInMonth()" 
        class="calendar-day"
        [class.selected]="isDaySelected(day)"
        [class.today]="isToday(day)"
        [class.empty]="!day"
        [class.disabled]="isDayDisabled(day)"
        (click)="selectDay(day)">
        {{ day || '' }}
      </div>
    </div>

  </div>
</div>
